import * as Yup from 'yup';

const schemaText = () => {
  return Yup.object().shape({
    message: Yup.string().required()
  });
};

export default schemaText;
